import { Experiment } from '@cian/experiments/ab';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { useRecommendationsEventsSubscribe } from './hooks/useRecommendationsEventsSubscribe';
import { Recommendations } from '../../components/Recommendations';
import { AUD_MOBILE_INCREASE_RECS_DEPTH } from '../../constants/experiments';
import { selectCurrentRegionId, selectParentRegion } from '../../selectors/regions';
import { ELandingType } from '../../types/landingType';

export const RecommendationsContainer = () => {
  const regionId = useSelector(selectCurrentRegionId);
  const parentId = useSelector(selectParentRegion);

  useRecommendationsEventsSubscribe();

  // Обёртка div нужна, чтобы в микрофронт не пробрасывалась пропса data-name, иначе падает с ошибкой
  return (
    <div>
      <Experiment name={AUD_MOBILE_INCREASE_RECS_DEPTH} group="A" default>
        <Recommendations regionId={parentId ?? regionId} landingType={ELandingType.MainPage} isNeedMargin />
      </Experiment>
      <Experiment name={AUD_MOBILE_INCREASE_RECS_DEPTH} group="B">
        <Recommendations regionId={parentId ?? regionId} landingType={ELandingType.MainPage} />
      </Experiment>
    </div>
  );
};
